export const CLEAR_METAMASK_ADDRESS = (state) => {
  state.metamask_address = "";
};

export const SET_METAMASK_ADDRESS = (state, metamask_address) => {
  state.metamask_address = metamask_address;
};
